<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{
              isJp
                ? $t('subMenu.sumahoDeBikkurapon-jp')
                : $t('subMenu.sumahoDeBikkurapon')
            }}
          </h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel">
        <div class="x_content">
          <alert
            :title="$t('subMenu.sumahoDeBikkuraponConfig')"
            :success-message="$t('common.hasUpdated')"
            :error-message="$t('common.hasNotUpdated')"
            :alerts="alerts"
            :errors="errors"
            :display="wasTheRequestSuccessful"
            @closeAlert="closeAlert"
          />
          <div class="text-right">
            <span @click="submit" class="btn btn-primary">{{
              $t('operationalManagementPage.update')
            }}</span>
          </div>

          <div>
            <div class="x_title">
              <h2>{{ $t('operationalManagementPage.globalSettings') }}</h2>
              <div class="clearfix"></div>
            </div>
            <div class="row">
              <div class="form-group">
                <div class="col-md-4 col-sm-4 col-xs-12">
                  <label class="control-label" for="shop"
                    >{{
                      isJp
                        ? $t('subMenu.sumahoDeBikkurapon-jp')
                        : $t('subMenu.sumahoDeBikkurapon')
                    }}： <span class="required">*</span></label
                  >
                </div>
                <div class="form-group col-md-4 col-sm-4 col-xs-4">
                  <label class="control-label" for="" style="margin-right: 10px"
                    >{{ $t('orderPage.inOperation') }}:</label
                  >
                  <input
                    id="sumahoDeBikkuraponT"
                    v-model="sumahoDeBikkurapon"
                    :disabled="isConfirmView"
                    type="radio"
                    class="flat"
                    name="sumahoDeBikkurapon"
                    value="1"
                    required
                  />
                </div>
                <div class="form-group col-md-4 col-sm-4 col-xs-4">
                  <label class="control-label" style="margin-right: 10px"
                    >{{ $t('operationalManagementPage.stopping') }}:</label
                  >
                  <input
                    id="sumahoDeBikkuraponF"
                    v-model="sumahoDeBikkurapon"
                    :disabled="isConfirmView"
                    type="radio"
                    class="flat"
                    name="sumahoDeBikkurapon"
                    value="0"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <div class="col-md-4 col-sm-4 col-xs-12">
                  <label class="control-label" for="shop"
                    >{{ $t('operationalManagementPage.emissionSetting') }}：
                    <span class="required">*</span></label
                  >
                </div>
                <div class="form-group col-md-4 col-sm-4 col-xs-4">
                  <label class="control-label" for="" style="margin-right: 10px"
                    >{{ $t('operationalManagementPage.numberOfTimes') }}:</label
                  >
                  <input
                    id="bikkuraponPutOutT"
                    v-model="bikkuraponPutOut"
                    :disabled="isConfirmView"
                    type="radio"
                    class="flat"
                    name="bikkuraponPutOut"
                    value="1"
                    required
                  />
                </div>
                <div class="form-group col-md-4 col-sm-4 col-xs-4">
                  <label class="control-label" style="margin-right: 10px"
                    >{{ $t('operationalManagementPage.probability') }}:</label
                  >
                  <input
                    id="bikkuraponPutOutF"
                    v-model="bikkuraponPutOut"
                    :disabled="isConfirmView"
                    type="radio"
                    class="flat"
                    name="bikkuraponPutOut"
                    value="2"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="ln_solid"></div>

          <div class="x_title">
            <h2>{{ $t('operationalManagementPage.individualSetting') }}</h2>
            <div class="clearfix"></div>
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-md-offset-6 col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :display-items="shops"
                  :column-titles="tableHeaderColumns"
                  @selectEvent="selectEvent"
                  @inputEvent="inputEvent"
                  @sortTable="sortTable"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/common/table/Table'
import Alert from '@/components/common/alert/Alert'
import Search from '@/utility/WordSearch'
import { mapGetters } from 'vuex'
import BikkuraponRequest from '@/http/BikkuraponRequest'
export default {
  components: {
    AppTable: Table,
    Alert,
  },
  data() {
    return {
      tableHeaderColumns: [
        this.$t('common.shopId'),
        this.$t('common.shopName'),
        this.$t('operationalManagementPage.bikkuraponInstallation'),
        this.$t('operationalManagementPage.amountOfMoney'),
        this.$t('operationalManagementPage.rotation'),
        this.$t('operationalManagementPage.probabilityPercent'),
      ],
      sumahoDeBikkurapon: 0,
      bikkuraponPutOut: 1,
      shops: [],
      errors: null,
      alerts: '',
      isConfirmView: false,
      wasTheRequestSuccessful: false,
      searchString: '',
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'bikkurapon/getSettings',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.bikkuraponPutOut = data.bikkuraponPutOut
      this.sumahoDeBikkurapon = data.sideMenuBikkurapon
      this.shops = data.shops.map((item) => {
        const enableList = [
          this.$t('operationalManagementPage.notInstalled'),
          this.$t('operationalManagementPage.off'),
          this.$t('operationalManagementPage.on'),
        ]
        return [
          item.shopId,
          item.name,
          {
            type: 'select',
            id: item.shopId,
            selected: item.enabled,
            options: enableList,
            target: 'enabled',
          },
          {
            type: 'input',
            mode: 'number',
            id: item.shopId,
            inputValue: item.drawAmount,
            target: 'drawAmount',
          },
          {
            type: 'input',
            mode: 'number',
            id: item.shopId,
            inputValue: item.rounds,
            target: 'rounds',
          },
          {
            type: 'input',
            mode: 'number',
            id: item.shopId,
            inputValue: item.probability,
            target: 'probability',
          },
        ]
      })
      this.allShops = this.shops
    },
    language() {
      this.$store.dispatch('bikkurapon/getSettings')
    },
  },
  mounted() {
    this.$store.dispatch('bikkurapon/getSettings')
  },
  methods: {
    submit: function() {
      const request = new BikkuraponRequest()
      const params = {
        sideMenuBikkurapon: Number(this.sumahoDeBikkurapon),
        bikkuraponPutOut: Number(this.bikkuraponPutOut),
        shops: [],
      }
      const shops = this.shops.map((item) => {
        return {
          shopId: item[0],
          enabled: item[2].selected,
          drawAmount: item[3].inputValue,
          rounds: item[4].inputValue,
          probability: item[5].inputValue,
        }
      })
      params.shops = shops
      request
        .update(params)
        .then(() => {
          this.alerts = 'success'
        })
        .catch((error) => {
          this.errors = error.response.data
          this.alerts = 'error'
        })
        .finally(() => {
          this.wasTheRequestSuccessful = true
        })
    },
    selectEvent: function(selectValue, id) {
      const key = this.shops.findIndex((i) => i[0] === id)
      this.shops[key][2].selected = selectValue
    },
    inputEvent: function(value, id, target) {
      const key = this.shops.findIndex((i) => i[0] === id)
      switch (target) {
        case 'drawAmount':
          this.shops[key][3].inputValue = Number(value)
          break

        case 'rounds':
          this.shops[key][4].inputValue = Number(value)
          break

        case 'probability':
          this.shops[key][5].inputValue = Number(value)
          break
      }
    },
    closeAlert: function() {
      this.wasTheRequestSuccessful = false
    },
    sortTable: function(newArray) {
      this.shops = newArray
    },
    searchWord: function() {
      this.shops = Search.searchFromCollection(this.allShops, this.searchString)
    },
  },
}
</script>
